import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[fastHeaderFormat]'
})
export class FastHeaderFormatDirective {
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.getElementsByClassName(
      'mat-card-header-text'
    )[0].style.margin = 0;
  }
}
